/**
 * Help copy for the Fit and Propensity scores, shown in the account-list
 * sidebar info tooltip. The bold "Fit Score:" / "Propensity Score:" labels are
 * rendered by the consumer; these strings are just the descriptions.
 */
export const FIT_SCORE_HELP =
  'This takes into account details about the company — size, industry, tech stack. It answers the question — "Is the company a good fit?"';
export const PROPENSITY_SCORE_HELP =
  'It takes into account recent engagement, buying intent signals, and stakeholder involvement. It answers the question — "Should I reach out now?"';
